import {AdxAlertRule} from "../../../models/rules/TradingAlertRule";
import {AlertDialogRule} from "./AlertDialogRule";
import {TradingAlertRuleType} from "../../../models/rules/TradingAlertRuleType";
import {AdxAlertType} from "../rules/adx/models/AdxAlertType";

interface AdxRuleProperties {
    adxType: AdxAlertType;
}

export type AlertDialogAdxRule = AdxRuleProperties & AdxAlertRule & AlertDialogRule;

export function isDialogAdxRule(rule: AlertDialogRule): rule is AlertDialogAdxRule {
    return "type" in rule && rule.type === TradingAlertRuleType.ADX;
}
